import React, { FC, MouseEvent, MutableRefObject, ReactElement, useRef, useState } from 'react'
import { ButtonGroup } from '@material-ui/core'
import { IconName, IconSize } from '../../../../NonReact/constants/React/Icon/Constants'
import PopperContent from '../PopperContent'
import { ReactState } from '../../Types/Types'
import { PopoverItems } from './Types'
import Icon from '../Icon'
import { RoundedButton } from '../../../../ReactRouting/Components/Atoms/RoundedButton/RoundedButton'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

type Props = {
    className?: string
    items: PopoverItems[]
    title?: string
    isRouterMode?: boolean
}
export const ButtonSplitIcon: FC<Props> = ({ className, items, title, isRouterMode }: Props): ReactElement => {
    const [isOpen, setIsOpen]: ReactState<boolean> = useState<boolean>(false)
    const ref: MutableRefObject<null> = useRef<null>(null)

    const handleClick = (e: MouseEvent<Element, globalThis.MouseEvent>): void => {
        e.preventDefault()
        setIsOpen(!isOpen)
    }

    return (
        <ButtonGroup
            className={`btnsi-group ${className} ${isRouterMode ? 'router-btnsi-group' : EMPTY_STRING}`}
            ref={ref}
            variant='contained'
        >
            <RoundedButton className='btnsi-main' onClick={handleClick} shrink>
                {title}
            </RoundedButton>
            <RoundedButton className='btnsi-icon' onClick={handleClick} shrink>
                <Icon iconName={IconName.ARROW_DOWN} iconSize={IconSize.MEDIUM} />
            </RoundedButton>
            <PopperContent
                className='btnsi-popover'
                anchorEl={ref.current}
                open={isOpen}
                setOpen={setIsOpen}
                isClickAwayHandled
            >
                <div className='btnci-pop-container'>
                    {items
                        .filter((item: PopoverItems): boolean => !item.isDisabled)
                        .map(
                            (
                                { label, buttonClassNames, href, download }: PopoverItems,
                                index: number
                            ): ReactElement => (
                                <a
                                    key={`btnsi-${label}-${index}`}
                                    className={`btnsi-entry ${buttonClassNames}`}
                                    href={href ?? '#'}
                                    target='_blank'
                                    download={download ?? false}
                                    rel='noreferrer'
                                >
                                    <span>{label}</span>
                                </a>
                            )
                        )}
                </div>
            </PopperContent>
        </ButtonGroup>
    )
}
